import { settings } from '@/api'
import TokenService from '@/services/token.service'

import {
	SETTINGS_LOADING_STATUS,
	SETTINGS_GET_ERROR,
	SETTINGS_SECURITY_ERROR,
	LOGIN_SETTINGS_GET,
	APP_CORE_SETTINGS_GET,
	CHAPTERS_GET,
	CI_CD_SETTINGS_GET,
	STYLE_SETTINGS_GET,
	CORE_SETTINGS_GET,
	WEB_SETTINGS_GET,
	USER_SETTINGS_GET,
	BACK_USER_SETTINGS_GET,
	EVENT_SETTINGS_GET,
	SETTINGS_REGISTRATION_FIELDS_GET,
	SETTINGS_REGISTRATION_FIELDS_LOADING,
	SETTINGS_GET_LIST_FIELDS,
	SETTINGS_GET_LIST_FIELDS_LOADING,
	SETTINGS_SET_DWH_DISABLED,
	SETTINGS_INC_DWH_FAIL,
	SETTINGS_RESET_DWH_FAIL,
} from './types'
import { cacheSetting } from '../../utils/helpers'
import axios from 'axios'

const getListBySource = async ({ commit }, { source, page = 1 }) => {
	commit(SETTINGS_GET_LIST_FIELDS_LOADING, { source, loading: true })

	try {
		const { data, headers } = await settings.getListBySource(source, page)
		commit(SETTINGS_GET_LIST_FIELDS, { source, data, headers })
	} catch (e) {
		console.error(e)
	} finally {
		commit(SETTINGS_GET_LIST_FIELDS_LOADING, { source, loading: false })
	}
}

const fetchSettings = async (ctx) => {
	ctx.commit(SETTINGS_LOADING_STATUS, true)
	try {
		const { data } = await settings.getSettings()

		ctx.commit(LOGIN_SETTINGS_GET, data)
		ctx.commit(SETTINGS_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(SETTINGS_GET_ERROR, e)
		console.error(e)
	}
}

const changePassword = async (ctx, passwordData) => {
	try {
		await settings.changePassword(passwordData)
	} catch (e) {
		ctx.commit(SETTINGS_SECURITY_ERROR, e)
		console.error(e)
		throw e
	}
}

const setNotifications = async (ctx, notificationsData) => {
	try {
		await settings.setNotifications(notificationsData)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const fetchChapters = async (ctx) => {
	ctx.commit(SETTINGS_LOADING_STATUS, true)
	try {
		const { data } = await settings.fetchChapters()
		ctx.commit(CHAPTERS_GET, data)
		ctx.commit(SETTINGS_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(SETTINGS_LOADING_STATUS, false)
		throw e
	}
}

const getLoginSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=login')
			ctx.commit(LOGIN_SETTINGS_GET, data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getBackUserSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=back-user')
			ctx.commit(BACK_USER_SETTINGS_GET, data)
			cacheSetting('back_user', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getAppCoreSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=app-core')
			ctx.commit(APP_CORE_SETTINGS_GET, data)
			cacheSetting('app_core', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getStyleSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=styles')
			ctx.commit(STYLE_SETTINGS_GET, data)
			cacheSetting('styles', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getEventsSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=event')
			ctx.commit(EVENT_SETTINGS_GET, data)
			cacheSetting('event', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getBaseCoreSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=core')
			ctx.commit(CORE_SETTINGS_GET, data)
			cacheSetting('core', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getUserSettings = async (ctx) => {
	try {
		ctx.commit(SETTINGS_LOADING_STATUS, true)
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=user')
			ctx.commit(USER_SETTINGS_GET, data)
		}
	} catch (e) {
		console.log(e)
		throw e
	} finally {
		ctx.commit(SETTINGS_LOADING_STATUS, false)
	}
}

const getWebBlockSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=web')
			ctx.commit(WEB_SETTINGS_GET, data)
			cacheSetting('web', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getCiCdSettings = async (ctx) => {
	try {
		const url = ctx.state.url
		if (url) {
			const { data } = await axios.get(url + '/settings?module=ci-cd')
			ctx.commit(CI_CD_SETTINGS_GET, data)
			cacheSetting('ci_cd', data)
		}
	} catch (e) {
		console.log(e)
		throw e
	}
}

const getRegistrationFields = async (ctx, id) => {
	ctx.commit(SETTINGS_REGISTRATION_FIELDS_LOADING, true)
	try {
		const { data } = await settings.getRegistrFields(id)
		ctx.commit(SETTINGS_REGISTRATION_FIELDS_GET, data)
	} catch (e) {
		console.log(e)
		throw e
	} finally {
		ctx.commit(SETTINGS_REGISTRATION_FIELDS_LOADING, false)
	}
}
const getDwhUrl = async (ctx) => {
	try {
		const { data } = await settings.getDwhUrl()
		cacheSetting('dwh', data)
		ctx.dispatch('sendDwhAction', {
			credentials: data,
			payload: {
				category: 'App Start',
				action: 'app_launch',
				module: 'App Launch',
				session_id: ctx.rootGetters['app/sessionId'],
				version: process.env.VUE_APP_VERSION,
				platform: 'web app',
				login: TokenService.getEmailFromStorage() || null,
			},
		}).catch(() => {})
	} catch (e) {
		console.warn('[DWH] getDwhUrl failed (suppressed):', e?.response?.status, e?.message)
		ctx.commit(SETTINGS_SET_DWH_DISABLED, true)
	}
}

const sendDwhAction = async (ctx, { credentials, payload }) => {
	if (ctx.state.dwhDisabled) return
	if (!credentials?.url || !credentials?.auth_key) return
	console.log('dwh', payload)
	try {
		await axios.post(credentials.url, payload, {
			headers: { 'access-token': credentials.auth_key },
			timeout: 3000,
			validateStatus: () => true,
		})

		ctx.commit(SETTINGS_RESET_DWH_FAIL)
	} catch (e) {
		console.warn('[DWH] send failed (suppressed):', e?.message)
		ctx.commit(SETTINGS_INC_DWH_FAIL)
		if (ctx.state.dwhFailCount >= 3) {
			ctx.commit(SETTINGS_SET_DWH_DISABLED, true)
			setTimeout(() => ctx.commit(SETTINGS_SET_DWH_DISABLED, false), 5 * 60 * 1000)
			ctx.commit(SETTINGS_RESET_DWH_FAIL)
		}
	}
}
const getAdvertisementUrl = async () => {
	try {
		const { data } = await settings.getAdvertisementUrl()
		if (
			data?.success &&
			data?.url &&
			data?.auth_key &&
			typeof data.url === 'string' &&
			data.url.length > 0
		) {
			cacheSetting('advertisement', data)
			return data
		}
		console.warn('Invalid advertisement settings received:', data)

		const fallback = {
			success: false,
			fallback: true,
			url: null,
			auth_key: null,
		}

		cacheSetting('advertisement', fallback)
		return fallback
	} catch (e) {
		console.warn('Failed to load advertisement settings:', e?.message)

		const fallback = {
			success: false,
			fallback: true,
			url: null,
			auth_key: null,
		}

		cacheSetting('advertisement', fallback)
		return fallback
	}
}

export default {
	getCiCdSettings,
	getStyleSettings,
	fetchSettings,
	changePassword,
	getLoginSettings,
	getAppCoreSettings,
	setNotifications,
	fetchChapters,
	getBaseCoreSettings,
	getWebBlockSettings,
	getUserSettings,
	getBackUserSettings,
	getEventsSettings,
	getDwhUrl,
	sendDwhAction,
	getRegistrationFields,
	getAdvertisementUrl,
	getListBySource,
}
